export default {"src":"/_next/static/media/tick.95d7e7bf.svg","height":15,"width":19,"blurWidth":0,"blurHeight":0};